module.exports = __webpack_public_path__ + "static/media/screen7.485ba05e.png";